svg{width:100%;height:100%}
/*# sourceMappingURL=projection-renderer.component.css.map */
